"use client";

import Link from "next/link";
import { useContext } from "react";
import { AppContext } from "@/context/AppContext";
import { useData, useLocalePath } from "@/i18n/LangContext";
import LanguageSwitch from "./LanguageSwitch";

// Fixe Bottom-Leiste, nur Desktop (md+). Mobil übernimmt MobileFooter
// am Ende des Content-Flows — dort ist mehr Platz.
export default function Footer() {
  const { activePage, isOnCvSubdomain } = useContext(AppContext);
  const { ui } = useData();
  const lp = useLocalePath();
  const currentYear = new Date().getFullYear();

  // Diese Funktion fügt die Domain hinzu, wenn wir auf der CV-Subdomain sind
  const getHref = (path: string): string => {
    const localized = lp(path);
    if (isOnCvSubdomain) {
      return `https://robinwichmann.com${localized}`;
    }
    return localized;
  };

  return (
    <div className={`wrapper wrapper--bottom ${activePage}-page hidden md:block`}>
      <footer className="navigation">
        <div className="navigation--frame">
          <div className="navigation--container">
            <nav className="flex items-center justify-between w-full px-4">
              <div className="text-white/60 text-sm mr-4">
                © {currentYear} Robin Wichmann
              </div>
              <div className="flex items-center gap-2">
                <LanguageSwitch />
                <Link
                  href={getHref("/imprint")}
                  className={`footer--link no-select text-sm ${activePage === 'imprint' ? 'router-link-active' : ''}`}
                  style={activePage === 'imprint' ? { color: '#a2fad8' } : {}}
                >
                  {ui.footer.imprint}
                </Link>
                <Link
                  href={getHref("/privacy")}
                  className={`footer--link no-select text-sm ${activePage === 'privacy' ? 'router-link-active' : ''}`}
                  style={activePage === 'privacy' ? { color: '#afcf66' } : {}}
                >
                  {ui.footer.privacy}
                </Link>
              </div>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
}
